"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _excluded = ["title", "titleId"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SvgAssign = function SvgAssign(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#37D5D3",
    cx: 12.125,
    cy: 11,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A470D5",
    cx: 12.125,
    cy: 37,
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.225 12.872a8.254 8.254 0 0 1 7.845 5.69 10.97 10.97 0 0 1-7.945 3.391 10.966 10.966 0 0 1-7.795-3.238 8.257 8.257 0 0 1 7.895-5.843Zm1.375-8.25c1.14 0 2.063.923 2.063 2.062v2.75c0 1.14-.924 2.063-2.063 2.063h-2.75a2.062 2.062 0 0 1-2.063-2.063v-2.75c0-1.139.924-2.062 2.063-2.062h2.75ZM12.125 38.672a8.254 8.254 0 0 1 7.916 5.92 10.97 10.97 0 0 1-7.916 3.361 10.968 10.968 0 0 1-7.915-3.361 8.252 8.252 0 0 1 7.915-5.92Zm0-8.25a3.438 3.438 0 1 1 0 6.875 3.438 3.438 0 0 1 0-6.875Z",
    fill: "#FFF",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.362 37 5.405 5.405a.817.817 0 0 1-1.155 1.155l-5.405-5.405-5.405 5.405a.817.817 0 0 1-1.155-1.155L36.052 37l-5.405-5.405a.817.817 0 1 1 1.155-1.155l5.405 5.405 5.405-5.405a.817.817 0 1 1 1.155 1.155L38.362 37Z",
    fill: "#FA7240",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.6 5.115-8.5 8.978-4.285-4.73a.715.715 0 0 0-1.082 0 .907.907 0 0 0 0 1.194l4.81 5.311c.164.182.36.265.556.264a.728.728 0 0 0 .542-.247l9.04-9.576a.907.907 0 0 0 0-1.194.715.715 0 0 0-1.082 0Z",
    fill: "#A0DB77"
  })));
};

var _default = SvgAssign;
exports["default"] = _default;